/** Format Cooori-admin timestamps in the Admin SPA's fixed business timezone. */
export function formatAdminDate(value: string | null): string {
  if (value === null) return '—'
  return new Intl.DateTimeFormat('en', {
    dateStyle: 'medium',
    timeStyle: 'short',
    timeZone: 'Asia/Tokyo',
  }).format(new Date(value))
}
